// extracted by mini-css-extract-plugin
export default {"card":"j2-z"};